<template>
  <div class="d-flex p-3 flex-column">
    <GmbSection :displayLevel="1" title="Info">
      <template #picto>
        <FdText colorTheme4 fa>
          <i class="fas fa-map-marker-alt"/>
        </FdText>
      </template>

      <GmbRow alignControlsOnTop>
        <template #picto>
          <FdText colorTheme4 fa>
            <i class="fa-solid fa-id-card-clip"/>
          </FdText>
        </template>

        <div class="d-flex flex-column">
          <FdText bold colorTheme4 tag="label">Libellé</FdText>
          <FdText class="mt-1" tag="span">{{ organizationLabel }}</FdText>
        </div>
      </GmbRow>

      <GmbRow alignControlsOnTop class="mt-2">
        <template #picto>
          <FdText colorTheme4 fa>
            <i class="fas fa-people-group"/>
          </FdText>
        </template>

        <div class="d-flex flex-column">
          <FdText bold colorTheme4 tag="label">Effectif théorique</FdText>
          <FdText class="mt-1" tag="span">{{
              theoreticalIndividualWorkforce
            }}
          </FdText>
        </div>
      </GmbRow>

      <GmbRow alignControlsOnTop class="mt-2">
        <template #picto>
          <FdText colorTheme4 fa>
            <i class="fas fa-building"/>
          </FdText>
        </template>

        <div class="d-flex flex-column">
          <FdText bold colorTheme4 tag="label">Adresse</FdText>
          <FdText class="mt-1" tag="span">{{
              activatedLocation.label
            }}
          </FdText>
        </div>
      </GmbRow>

      <GmbRow v-if="otherLocations.length" alignControlsOnTop class="mt-2">
        <template #picto>
          <FdText colorTheme4 fa>
            <i class="fas fa-building"/>
          </FdText>
        </template>

        <div class="d-flex flex-column">
          <FdText bold colorTheme4 tag="label">Autre(s) adresse(s)</FdText>
          <div
              v-for="(location, i) in otherLocations"
              :class="['d-flex flex-column', { 'mt-1': i != 0 }]"
              :key="i"
          >
            <FdText class="mt-1" tag="span">{{
                location.label
              }}
            </FdText>
          </div>
        </div>
      </GmbRow>
    </GmbSection>
  </div>
</template>

<script>
import {formatFrenchAddress} from "@/helpers.js";

import FdText from "@/flexdesign/Text";

import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";

export default {
  name: "GmbOrganizationMapPointInfo",

  components: {
    FdText,
    GmbRow,
    GmbSection,
  },

  props: {
    activatedLocation: Object,
    organizationLabel: String,
    otherLocations: Array,
    theoreticalIndividualWorkforce: Number,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
